import { Box, Typography } from "@mui/material";
import ChildHeaderCard from "../card-templates/ChildHeaderCard";
import { getIcon } from "../../../utils/iconConfig";
import usePurchaseAndCategoryData from "../../../features/home/api/HomeScreenApi";
import { useGlobalContext } from "../../../context/GlobalContext";
import TabSkeleton from "../TabSkeleton";
import { useEffect, useState } from "react";
import SynopsisDrawer from "../../../features/synopsis/SynopsisDrawer";
import { isBinnysClient } from "../../../utils/clientLabel";

const HomeHeader = () => {
  const { selectedCard, setPayload, homeScreen } = useGlobalContext();

  const ClientData = JSON.parse(localStorage.getItem("ClientData"));
  const clientCode = ClientData?.clientCode;
  const clientName =
    ClientData?.name === "Binnys Jewellery Pvt. Ltd. (Client not Found)"
      ? ClientData?.newClientName
      : ClientData?.name;
  const [synopsisOpen, setSynopsisOpen] = useState(false);
  // No synopsis for Binnys Jewellery Private Limited (BJPL) itself.
  const isBJPL = clientCode === "BJPL" || isBinnysClient(ClientData?.name);

  const { data, isLoading } = usePurchaseAndCategoryData(
    clientCode,
    selectedCard
  );

  useEffect(() => {
    setPayload({
      avgDiaWeight: data?.avgDiaWeight,
      avgNetWeight: data?.avgNetWeight,
    });
  }, [data]);

  const dummyData = [
    {
      icon: getIcon("Tag"),
      key: "Previously Purchased : ",
      value: `${
        data?.previousPurchaseCount != 0
          ? `${data?.previousPurchaseCount} pcs`
          : "New"
      }`,
    },
    {
      icon: getIcon("Diamond", "back"),
      key: "Category Avg Diamond : ",
      value: `${data?.avgDiaWeight || 0} ct`,
    },
    {
      icon: getIcon("GoldBar", "back"),
      key: "Category Avg Gold : ",
      value: `${data?.avgNetWeight || 0} g`,
    },
    // { icon: getIcon("Score"), key: "Design Buy Score : ", value: "67 %" },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        height: homeScreen ? "12vh" : "10.75vh",
        borderLeft: ".1vw solid #0d0d0d",
        borderBottom: homeScreen ? ".1vw solid #0d0d0d" : ".15vw solid #0d0d0d",
      }}
    >
      <Box
        sx={{
          width: "100%",
          boxSizing: "border-box",
          height: "100%",
          background: "#000000",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          padding: "1vw",
          gap: "1.5vw",
          overflowX: "auto",
          overflowY: "hidden",
        }}
      >
        {isLoading ? (
          <TabSkeleton height={"3vw"} width={"17vw"} count={3} />
        ) : (
          dummyData?.map((data, index) => (
            <ChildHeaderCard
              key={index}
              icon={data?.icon}
              title={data?.key}
              value={data?.value}
              width={"17vw"}
              borderRadius={".5vw"}
            />
          ))
        )}
        {clientCode && !isBJPL && (
          <Box
            onClick={() => setSynopsisOpen(true)}
            sx={{
              marginLeft: "auto",
              flexShrink: 0,
              padding: ".55vw 1.2vw",
              border: ".05vw solid #50C878",
              borderRadius: ".4vw",
              cursor: "pointer",
              userSelect: "none",
              "&:hover": { background: "#50C87822" },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Poppins",
                fontSize: ".85vw",
                fontWeight: 500,
                color: "#50C878",
              }}
            >
              Synopsis
            </Typography>
          </Box>
        )}
      </Box>
      <SynopsisDrawer
        open={synopsisOpen}
        onClose={() => setSynopsisOpen(false)}
        clientCode={clientCode}
        clientName={clientName}
      />
    </Box>
  );
};

export default HomeHeader;
